import { render, staticRenderFns } from "./EmptyPage.vue?vue&type=template&id=515ad0e2&scoped=true&"
import script from "./EmptyPage.vue?vue&type=script&lang=ts&"
export * from "./EmptyPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyPage.vue?vue&type=style&index=0&id=515ad0e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ad0e2",
  null
  
)

export default component.exports